import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'
// import store from '@/store'

async function getLanguages () {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLanguages.data)
      }, 500)
    })
  } else {
    const req = {
      url: '/languages',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params: { paginate: false }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getLanguages }
